function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from '../../_snowpack/pkg/react.js';
import styled from '../../_snowpack/pkg/styled-components.js';
const defaultSize = '20px';

const setWidth = ({
  size,
  width
}) => width || size || defaultSize;

const SVG = styled.svg.withConfig({
  displayName: "trashcan-lid__SVG",
  componentId: "sc-1j403vz-0"
})(["width:", ";height:60px;.icon-trashcan-fill{fill:none;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke:", ";}"], setWidth, p => p.color || 'currentColor');
export default function TrashcanLid({
  fill,
  ...rest
}) {
  return /*#__PURE__*/React.createElement(SVG, _extends({
    viewBox: "0 0 40 40"
  }, rest, {
    fill: fill
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "icon-trashcan-fill",
    style: {
      strokeWidth: '1.2'
    },
    d: "M22.5,9.2h-5c-0.9,0-1.7,0.8-1.7,1.7v1.7h8.4v-1.7C24.2,9.9,23.4,9.2,22.5,9.2z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "icon-trashcan-fill",
    style: {
      strokeWidth: '1.2'
    },
    x1: "10.9",
    y1: "12.5",
    x2: "26.5",
    y2: "12.5"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "icon-trashcan-fill",
    style: {
      strokeWidth: '1.2'
    },
    x1: "31.8",
    y1: "12.5",
    x2: "8.2",
    y2: "12.5"
  }))));
}